import _extends from '@babel/runtime-corejs3/helpers/extends';
import React__default from 'react';
import classNames from 'classnames';
import styles from './Link2.js';

const Link = /*#__PURE__*/React__default.forwardRef((_ref, ref) => {
  let {
    children,
    href = '#',
    target = '_self',
    className,
    ...rest
  } = _ref;
  const classes = classNames(className, styles.link);
  const rel = target !== '_self' ? 'noopener noreferrer' : undefined;
  return /*#__PURE__*/React__default.createElement("a", _extends({}, rest, {
    ref: ref,
    href: href,
    target: target,
    rel: rel,
    className: classes
  }), children);
});

export { Link as default };
